import {Button, Table} from "antd"
import { TableLoader } from "../../shared"

export const MyTable=({columns, data, loading, pagination, onChange, size, paginationSize, ...props})=>{
    return (
        <Table
            columns={columns}
            dataSource={data || []}
            rowKey="id"
            pagination={{
                hideOnSinglePage: true,
                total: pagination?.totalRecords,
                pageSize: pagination?.pageSize,
                defaultPageSize: pagination?.pageSize,
                current: pagination?.pageNo,
                size: "default",
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (pageNo, pageSize) => onChange(pageNo, pageSize),
                showTotal: (total) => <Button size={paginationSize ||  "default"}>Total: {total}</Button>,
                size: paginationSize || "default"
            }}
            loading={
                {
                    ...TableLoader,
                    spinning: loading
                }
            }
            size={size || "small"}
            {...props}
        />
    )
}